<template>
  <c-row>
    <c-col sm="12" md="4">
      <c-card>
        <c-card-header>
          <!--            <div class="c-avatar">-->
          <!--              <img-->
          <!--                      src="img/avatars/6.jpg"-->
          <!--                      class="c-avatar-img "-->
          <!--              />-->
          <!--            </div>-->
          Welcome back {{ fullName }}
        </c-card-header>
        <c-card-body>
          <h2>Waiting for updates:</h2>
          <p class="lead">
            <a
              href="#"
              @click="
                () => {
                  return false;
                }
              "
            >
              <strong>{{ numberOfSitesRequiringUpdates }} Sites</strong>
            </a>
            |
            <a
              href="#"
              @click="
                () => {
                  return false;
                }
              "
            >
              <strong>8 Plugins</strong>
            </a>
            |
            <a
              href="#"
              @click="
                () => {
                  return false;
                }
              "
            >
              <strong>5 Themes</strong>
            </a>
          </p>
        </c-card-body>
      </c-card>
    </c-col>
    <c-col sm="12" md="4">
      <c-widget-dropdown color="gradient-primary" header="94" text="Updates this month">
        <template #default>
          <c-dropdown color="transparent p-0" placement="bottom-end">
            <template #toggler-content>
              <c-icon name="cil-settings" />
            </template>
            <c-dropdown-item>Action</c-dropdown-item>
            <c-dropdown-item>Another action</c-dropdown-item>
            <c-dropdown-item>Something else here...</c-dropdown-item>
            <c-dropdown-item disabled>Disabled action</c-dropdown-item>
          </c-dropdown>
        </template>
        <template #footer>
          <c-chart-line-simple
            pointed
            class="mt-3 mx-3"
            style="height:80px"
            :data-points="[65, 59, 84, 84, 51, 55, 40]"
            point-hover-background-color="primary"
            label="Members"
            labels="months"
          />
        </template>
      </c-widget-dropdown>
    </c-col>
    <c-col sm="12" md="4">
      <c-widget-dropdown color="kb-primary" header="112" text="Hours saved this quarter">
        <template #default>
          <c-dropdown color="transparent p-0" placement="bottom-end">
            <template #toggler-content>
              <c-icon name="cil-settings" />
            </template>
            <c-dropdown-item>Action</c-dropdown-item>
            <c-dropdown-item>Another action</c-dropdown-item>
            <c-dropdown-item>Something else here...</c-dropdown-item>
            <c-dropdown-item disabled>Disabled action</c-dropdown-item>
          </c-dropdown>
        </template>
        <template #footer>
          <c-chart-bar-simple
            class="mt-3 mx-3"
            style="height:80px"
            background-color="#7fd8c2"
            label="Members"
            labels="months"
          />
        </template>
      </c-widget-dropdown>
    </c-col>
  </c-row>
</template>

<script>
import { CChartLineSimple, CChartBarSimple } from '../../charts/index.js';

export default {
  name: 'DashboardWidgets',
  components: { CChartLineSimple, CChartBarSimple },
  props: {
    fullName: String,
    numberOfSitesRequiringUpdates: Number,
    sites: Array,
    allowBetaFeatures: Boolean,
  },
};
</script>
